<template>
  <v-card class="bg" flat id="login">
    <v-row align="center" justify="center">
      <v-card class="elevation-1 pa-3 mt-16" width="450">
        <v-card-text>
          <div class="layout column align-center">
            <img src="@/assets/glyd.png" width="200" height="200" />
          </div>
        </v-card-text>
        <v-form
          ref="step3Form"
          v-model="finalFormValid"
          lazy-validation
          class="mt-n5 ma-5"
        >
          <v-row justify="center" class="mb-2">
            <span class="font-weight-bold">Reset password</span>
          </v-row>
          <v-text-field
            class="mt-5"
            label="New Password"
            v-model="newPassword"
            :rules="pwdRules"
            name="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            required
          />

          <v-text-field
            class="mb-2"
            label="Confirm Password"
            v-model="confirmPassword"
            :rules="pwdConfirm"
            name="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            required
          />

          <v-btn
            :loading="step3loading"
            @click="confirmPwd()"
            class="btn mb-3 #1b3249--text"
            >Confirm</v-btn
          >

          <v-btn text @click="onBackClick()" rounded class="mb-3 ml-2"
            >Back</v-btn
          >
        </v-form>
      </v-card>
    </v-row>
  </v-card>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  data() {
    return {
      show: false,
      show1: false,
      newPassword: "",
      confirmPassword: "",
      step3loading: false,
      pwdRules: [(v) => !!v || "Password required"],
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.newPassword || "Passwords do not match",
      ],
      rules: {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        code: [(v) => !!v || "Code is required"],
        // newPassword: [
        //   (v) => !!v || "required !",
        //   (v) => (v && v.length >= 8) || "Min 8 characters",
        // ],
        // confirmPassword: [
        //   (v) => !!v || "required !",
        //   (v) => (v && v.length >= 8) || "Min 8 characters",
        // ],
      },
    };
  },
  created() {
    //  console.log(this.$store.getters.get_session);
  },
  methods: {
    onBackClick() {
      //   alert(20);
      this.$router.push("/");
    },
    async confirmPwd() {
      //  this.$router.push("/")
      if (this.$refs.step3Form.validate()) {
        var inputData = {
          method_name: "CAUTH",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "NWPSDRQ",
            email_id: this.$store.getters.get_session.email,
            display_id: this.$store.getters.get_session.display_id,
            session: this.$store.getters.get_session.session,
            new_password: this.confirmPassword,
          },
        };
        var responseData = await apiCall(inputData);

        if (responseData.data.status == "00") {
          this.$router.push("/");
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
  },
};
</script>

<style lang="css">
.bg {
  background: #1b3249 !important;
}

.loginsmalltext {
  font-size: small;
  color: #1b3249;
}
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
